import React from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import Spinner from '../Spinner/Spinner';

import styles from './PreloadImage.module.css';

const PreloadImage = ({
  src,
  alt,
  className,
  loadingClass,
  width,
  height,
  imageLoaderClassName,
}) => {
  //console.log('??Preload ImAGE src = ' + src);

  return (
    <>
      <LazyLoadImage src={src} className={imageLoaderClassName + ' ' + className} alt={alt} width={width} height={height}>

      </LazyLoadImage>
      {/* <div className={[styles.Loading, loadingClass].join(' ')}>
        <span role="img" aria-label="">
          ⚠️
        </span>
      </div>
      <div className={[styles.Loading, loadingClass].join(' ')}>
        <Spinner type="small" />
      </div> */}
    </>
  );
};

export default PreloadImage;
